import React, { useState, useRef, useEffect } from 'react'
import './settings.css'
import MUIDataTable from 'mui-datatables'
import Checkbox from '@mui/material/Checkbox'
import { Modal, Grid } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { LocalForm, Control } from 'react-redux-form'
import Errors from '../../components/common/errors'
import { Row, Col, Button, FormGroup, Input, Label } from 'reactstrap'
import {
    invalidEmail,
    invalidPass,
    emptyEmail,
    adminFirstNameField,
    adminLastNameField,
    adminValid,
    firstValid,
    lastValid,
    invalidPass1,
    Password,
} from '../../utilities/message'
import Match from '../../utilities/validation'
import dayjs, { Dayjs } from 'dayjs'

import { FormControlLabel } from '@mui/material'
import { styled } from '@mui/material/styles'
import Switch, { SwitchProps } from '@mui/material/Switch'
import { useDispatch, useSelector } from 'react-redux'
import {
    userListing,
    deleteUsers,
    updateUserStatus,
    addAdmin,
    editAdmin,
    restoreAdmin
} from '../../actions/admin'

import Loader from '../../components/Loader'
import Moment from 'react-moment'
import 'moment-timezone'
import { format } from 'date-fns'
import Pagination from '@mui/material/Pagination'
import Stack from '@mui/material/Stack'
import { TableCell } from '@mui/material'
import { TableRow } from '@mui/material'
import { Avatar } from '@mui/material'
import { file } from '../../environment'
import {
    newPassword,
    confirmPassword,
    confirmPasswordNew,
    invalid6,
    invalid7,
    invalid8,
    passMatch,
    invalid2,
    invalid4,
    invalid5,
    invalid3,
} from '../../utilities/message'

const AdminManagement = ({ history }) => {
    const [deleteAllButton, setDeleteButton] = useState(false)
    const [openModal, setModal] = useState(false)
    const [pass, setPass] = useState(true)
    const [passVal, setPassVal] = useState('')

    const [open, setDeleteModal] = useState(false)
    const [openCongrModal, setOpenCongrModal] = useState(false)
    const [responsive, setResponsive] = useState('simple')
    const [value, setDateValue] = useState(dayjs('2022-04-17'))
    const dispatch = useDispatch()
    const admin = useSelector((state) => state.admin)
    const [data, setData] = useState([])
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [deleteIds, setDeleteIds] = useState([])
    const [duration, setDuration] = useState(0)
    const [search, setSearch] = useState('')
    const loaders = useSelector((state) => state.loader)
    const [edit, setEdit] = useState(false)
    const [editData, setEditData] = useState([])
    const [files, setFile] = useState(null)
    const [opendrag, setOpen] = useState()
    const [imageUrl, setImageUrl] = useState(null)
    const [error, setError] = useState('')
    const [imgerror, setImgError] = useState(false)
    const tableRef = useRef(null);
    const [tableHeight, setTableHeight] = useState('auto');

    useEffect(() => {
        const updateTableHeight = () => {
        if (tableRef.current) {
            const rect = tableRef.current.getBoundingClientRect();
            console.log("rect", rect);
            const remainingHeight = window.innerHeight - rect.top;
            const newHeight = remainingHeight - 60; // Subtract 100px as per requirement
            setTableHeight(newHeight);
            console.log(newHeight);
        }
        };

        updateTableHeight();
        window.addEventListener('resize', updateTableHeight);

        return () => {
        window.removeEventListener('resize', updateTableHeight);
        };
    }, []);

    // drag state
    const [dragActive, setDragActive] = React.useState(false)
    // ref
    const inputRef = React.useRef(null)

    // handle drag events
    const handleDrag = function (e) {
        e.preventDefault()
        e.stopPropagation()
        if (e.type === 'dragenter' || e.type === 'dragover') {
            setDragActive(true)
        } else if (e.type === 'dragleave') {
            setDragActive(false)
        }
    }

    // triggers when file is dropped
    const handleDrop = function (e) {
        e.preventDefault()
        e.stopPropagation()
        setDragActive(false)
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const MAX_FILE_SIZE = 5120 // 5MB

            const fileSizeKiloBytes = e.dataTransfer.files[0].size / 1024

            const allowedTypes = ['image/jpeg', 'image/png']
            if (fileSizeKiloBytes > MAX_FILE_SIZE) {
                setError('File size is greater than maximum limit')
                setImgError(true)
                return
            } else if (!allowedTypes.includes(e.dataTransfer.files[0]?.type)) {
                setError('Only JPEG, and PNG images are allowed.')
                setImgError(true)
                return
            } else {
                setError('')
                setImgError(false)
                getBase64(e.dataTransfer.files[0])
                    .then((result) => {
                        var file = result.split(',')
                        setFile(file[1])
                    })
                    .catch((err) => { })

                var reader = new FileReader()
                var url = reader.readAsDataURL(e.dataTransfer.files[0])

                reader.onloadend = function (e) {
                    setImgError(false)
                    setImageUrl(reader.result)
                }.bind(this)
            }
        }
    }

    const getBase64 = (file) => {
        return new Promise((resolve) => {
            let fileInfo
            let baseURL = ''
            // Make new FileReader
            let reader = new FileReader()

            // Convert the file to base64 text
            reader.readAsDataURL(file)

            // on reader load somthing...
            reader.onload = () => {
                // Make a fileInfo Object
                baseURL = reader.result
                resolve(baseURL)
            }
        })
    }

    // triggers when file is selected with click
    const handleChange = function (e) {
        setImageUrl(null)
        setFile(null)
        e.preventDefault()
        if (e.target.files && e.target.files[0]) {
            // const droppedFiles = Array.from(e.target.files[0]);
            // setFile(e.target.files[0]);
            const MAX_FILE_SIZE = 5120 // 5MB

            const fileSizeKiloBytes = e.target.files[0].size / 1024

            const allowedTypes = ['image/jpeg', 'image/png']
            if (fileSizeKiloBytes > MAX_FILE_SIZE) {
                setError('File size is greater than maximum limit')
                setImgError(true)
                return
            } else if (!allowedTypes.includes(e.target.files[0]?.type)) {
                setError('Only JPEG, and PNG images are allowed.')
                setImgError(true)
                return
            } else {
                setError('')
                setImgError(false)
                getBase64(e.target.files[0])
                    .then((result) => {
                        var file = result.split(',')

                        setFile(file[1])

                    })
                    .catch((err) => {
                    })

                var reader = new FileReader()
                var url = reader.readAsDataURL(e.target.files[0])

                reader.onloadend = function (e) {
                    setImgError(false)
                    setImageUrl(reader.result)
                }.bind(this)
            }
        }
    }

    // triggers the input when the button is clicked
    const onButtonClick = (e) => {
        e.preventDefault()
        inputRef.current.click()
    }

    const handleSave = (files) => {
        //Saving files to state for further use and closing Modal.
        setFile(files)
        setOpen(false)
    }
    const updatePagination = (e) => {
        setLimit(e.target.value)
        setPage(1)
        setDeleteButton(false)
        setDeleteIds([])
    }

    const restoreAction = (e, id, status) => {
        e.preventDefault()
        e.stopPropagation()
        dispatch(
            restoreAdmin({ id: id }, (res) => {
                const params = { page: page, limit: limit }
                // if (search != "" && search != null) {
                //   params.search = search;
                // }
                // if (duration != 0 && duration != null) {
                //   params.duration = duration;
                // }
                dispatch(
                    userListing(params, (res) => { }),
                )
            }),
        )
    }

    const singleDelete = (e, index) => {
        e.preventDefault()
        e.stopPropagation()
        setDeleteIds([admin.list[index]['id']])
        setDeleteModal(!open)
    }

    const deleteUser = () => {
        dispatch(
            deleteUsers({ deleteAdminIDS: deleteIds }, (res) => {
                setDeleteModal(!open)
                setDeleteButton(false)
                setDeleteIds([])
                const params = { page: page, limit: limit }
                if (search != '' && search != null) {
                    params.search = search
                }
                if (duration != 0 && duration != null) {
                    params.duration = duration
                }
                dispatch(
                    userListing(params, (res) => { }),
                )
            }),
        )
    }

    const editMerchantPopup = (data, e) => {
        e.preventDefault()
        e.stopPropagation()
        setImgError(false)
        setEdit(true)
        setEditData(data)
        setModal(true)
    }

    const updateValue = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1)
    }

    const setKeys = (e, id, status) => {
        e.preventDefault()
        e.stopPropagation()
        dispatch(
            editAdmin({ id: id, is_active: status }, (res) => {
                const params = { page: page, limit: limit }
                // if (search != "" && search != null) {
                //   params.search = search;
                // }
                // if (duration != 0 && duration != null) {
                //   params.duration = duration;
                // }
                dispatch(
                    userListing(params, (res) => { }),
                )
            }),
        )
    }

    useEffect(() => {
        const params = { page: page, limit: limit }
        if (search != '' && search != null) {
            params.search = search
        }
        if (duration != 0 && duration != null) {
            params.duration = duration
        }
        dispatch(
            userListing(params, (res) => { }),
        )
    }, [limit, page, duration, search])

    var newData = []
    //************Setting up paramters for table  */
    useEffect(() => {
        newData = admin.list.map((item, index) => {
            return [
                item.firstName + ' ' + item.lastName,
                item.email,
                item.created_at,
                item.is_active,
                item.id,
                item.firstName,
                item.lastName,
                item.is_deleted,
            ]
        })
        setTimeout(() => {
            setData(newData)
        }, 500)
    }, [admin.list])

    // const itemsOpen = (e, index) => {
    //   dispatch(updateSelectedMerchantId(merchant.list[index].id));
    //   history.push("/merchantItems");
    // };

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#625F6D' : '#442580',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#442580',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#442580',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }))

    const handleModal = () => {
        setModal(!openModal)
        setEdit(false)
        setEditData([])
        setImageUrl(null)
        setImgError(false)
    }
    const handleDeleteModal = (e) => {
        e.stopPropagation()
        // if(open){
        //   setDeleteButton(false);
        //   setDeleteIds([]);
        // }
        setDeleteModal(!open)
    }

    const style = {
        // transform: 'translate(160%, -4%)',
        width: 525,
        float: 'right',
        bgcolor: 'background.paper',
        // border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        height: '100%',
    }

    const styleDeletePopup = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 366,
        borderRadius: 10,
        bgcolor: 'background.paper',
        pt: 2,
        px: 4,
        pb: 3,
    }

    //************Setting up paramters for table  */

    const columns = [
        {
            name: 'name',
            label: 'Name',
            options: {
                filter: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            <span>Name</span>
                        </p>
                    )
                },
            },
        },
        {
            name: 'email',
            label: 'Email',
            options: {
                filter: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            <span>Email</span>
                        </p>
                    )
                },
            },
        },
        {
            name: 'Date Added',
            label: 'Date Added',
            options: {
                filter: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            Date Added
                        </p>
                    )
                },
                customBodyRenderLite: (index) => {
                    const date = data[index][2]
                    return (
                        <div style={{ width: '170px' }}>
                            <span>{format(new Date(parseInt(date)), 'dd MMM yyyy,')} </span>
                            <br /> <span>{format(new Date(parseInt(date)), ' hh:mm a')} </span>{' '}
                        </div>
                    )
                },
            },
        },
        {
            name: 'status',
            label: 'Status',
            options: {
                filter: true,

                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            Status
                        </p>
                    )
                },
                customBodyRenderLite: (index) => {
                    return (
                        <div className="actionField">
                            {data[index][7] == 1 ? (
                                <Button disabled className="inActiveButton">
                                    Deleted
                                </Button>
                            ) : data[index][3] == 1 ? (
                                <Button
                                    className="activeButton"
                                    title="Click to Inactivate"
                                    onClick={(e) => setKeys(e, admin.list[index]['id'], 0)}
                                >
                                    Active
                                </Button>
                            ) : (
                                <Button
                                    className="inActiveButton"
                                    title="Click to Activate"
                                    onClick={(e) => setKeys(e, admin.list[index]['id'], 1)}
                                >
                                    Inactive
                                </Button>
                            )}
                        </div>
                    )
                },
            },
        },
        {
            name: 'action',
            label: 'Action',
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (index) => {
                    return (
                        <div className="actionField">
                            {data[index][7] === 1 ? (
                                <Button
                                    className="activeButton"
                                    title="Restore"
                                    onClick={(e) => restoreAction(e, data[index][4])} // assuming restoreAction is your function to hit the API
                                >
                                    Restore
                                </Button>
                            ) : (
                                <>
                                    <Button
                                        className="editButton"
                                        title="Edit"
                                        onClick={(e) => editMerchantPopup(data[index], e)}
                                    >
                                        <img
                                            src={require('../../assets/images/Edit.png')}
                                            alt="Edit"
                                        />
                                    </Button>
                                    <Button
                                        className="deleteButton"
                                        title="Delete"
                                        onClick={(e) => singleDelete(e, index)}
                                    >
                                        <img
                                            src={require('../../assets/images/Delete.png')}
                                            alt="Delete"
                                        />
                                    </Button>
                                </>
                            )}
                        </div>
                    )
                },
            },
        },
    ]

    const handleAddSubmit = (e) => {
        if (edit) {
            update(e)
        } else {
            // if (files == null) {
            //   setImgError(true);
            //   setError("Logo should not be empty.");
            // } else {
            setImgError(false)
            const data = { ...e }

            dispatch(
                addAdmin(data, (res) => {
                    if (res) {
                        const params = { page: page, limit: limit }
                        // if (search != "" && search != null) {
                        //   params.search = search;
                        // }
                        // if (duration != "" && duration != null) {
                        //   params.duration = duration;
                        // }
                        // setFile(null);
                        // setOpenCongrModal(true);
                        setModal(false)
                        // setTimeout(() => {
                        //   setOpenCongrModal(false);
                        // }, [2000]);
                        dispatch(
                            userListing(params, (res) => { }),
                        )
                    }
                }),
            )
            // }
        }
    }

    const update = (e) => {
        var data

        data = { ...e, ...{ id: editData[4] } }

        delete data['email']
        dispatch(
            editAdmin(data, (res) => {
                if (res) {
                    const params = { page: page, limit: limit }
                    // if (search != "" && search != null) {
                    //   params.search = search;
                    // }
                    // if (duration != "" && duration != null) {
                    //   params.duration = duration;
                    // }
                    // setFile(null);
                    // setOpenCongrModal(true);
                    setModal(false)
                    // setTimeout(() => {
                    //   setOpenCongrModal(false);
                    // }, [2000]);
                    dispatch(
                        userListing(params, (res) => { }),
                    )
                }
            }),
        )
    }

    const setSearchValue = (data) => {
        setSearch(data)
        setPage(1)
    }

    const setNewPage = (page) => {
        setPage(page)
        setDeleteButton(false)
        setDeleteIds([])
    }

    const options = {
        //  filterType: 'checkbox',
        title: 'Pie Chart',
        filter: false,
        sort: true,
        sortOrder: {
            name: 'Date Added',
            direction: 'desc',  // Default sorting direction for the 'Date Added' column
          },
        print: false,
        viewColumns: false,
        download: false,
        pagination: false,
        // onRowClick: (rowData, rowMeta) => {
        //   dispatch(updateSelectedMerchantId(merchant.list[rowMeta.dataIndex].id));
        //   history.push("/merchantItems");
        // },

        rowsPerPage: 10,
        rowsPerPageOptions: [10, 20, 30],
        caseSensitive: false,
        search: false,
        jumpToPage: true,
        tableBodyHeight: tableHeight,
        tableBodyMaxHeight: "none",
        count: admin.total_users,
        onChangePage: (currentPage) => {
            setPage(currentPage + 1)
            return
        },
        onChangeRowsPerPage: (numberOfRows) => {
            setLimit(numberOfRows)
        },
        // expandableRows: true,
        // expandableRowsHeader: false,
        // expandableRowsOnClick: true,
        // isRowExpandable: (dataIndex, expandedRows) => {
        //   if (dataIndex === 3 || dataIndex === 4) return false;

        //   // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
        //   if (expandedRows.data.length > 4 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
        //     return false;
        //   return true;
        // },
        // rowsExpanded: [0, 1],
        // renderExpandableRow: (rowData, rowMeta) => {
        //   const colSpan = rowData.length + 1;
        //   return (
        //     <TableRow>
        //       <TableCell colSpan={colSpan}>
        //         {" "}
        //         <div class="container1 descriptoonBoxTable">
        //           <div>
        //             <p>
        //               Name: <span class="promo">{data[rowMeta.dataIndex][1]}</span>
        //             </p>
        //             <p>
        //               Email: <span class="promo">{data[rowMeta.dataIndex][2]}</span>
        //             </p>
        //             <p>
        //               Date:{" "}
        //               <span class="promo">
        //                 {format(
        //                   new Date(parseInt(data[rowMeta.dataIndex][3])),
        //                   "dd MMM yyyy ,  hh:mm a"
        //                 )}
        //               </span>
        //             </p>
        //             <p>
        //               Added By:{" "}
        //               <span class="promo">{data[rowMeta.dataIndex][4]}</span>
        //             </p>
        //             <p>
        //               Updated By:{" "}
        //               <span class="promo">{data[rowMeta.dataIndex][5]}</span>
        //             </p>
        //           </div>
        //           <div>
        //             <p>
        //               Street Address:{" "}
        //               <span class="promo">{data[rowMeta.dataIndex][6]}</span>
        //             </p>
        //             <p>
        //               City: <span class="promo">{data[rowMeta.dataIndex][7]}</span>
        //             </p>
        //             <p>
        //               State: <span class="promo">{data[rowMeta.dataIndex][8]}</span>
        //             </p>
        //             <p>
        //               Zipcode:{" "}
        //               <span class="promo">{data[rowMeta.dataIndex][9]}</span>
        //             </p>
        //           </div>
        //         </div>
        //       </TableCell>
        //     </TableRow>
        //   );
        // },
        //  page:page,
        //  customFooter: () => {
        //   return (
        //     <div className='pagediv'>

        //     <div className='pagination'>
        //         <p>Page</p>
        //         <img style={{cursor: page !== 1 ? "pointer" : "no-drop"}} onClick={()=> page !== 1 ? setPage(page-1) : null} src={require("../../assets/images/Vector 19.png")}/>
        //         <button>{page}</button>
        //         <img style={{cursor: user.nextPage !== 0 ? "pointer" : "no-drop"}} onClick={()=> user.nextPage !== 0 ? setPage(page+1) : null} src={require("../../assets/images/Vector 20.png")} />
        //         <select onChange={(e)=>updatePagination(e)} >
        //           <option selected={limit == 5}>5</option>
        //           <option selected={limit == 10}>10</option>
        //           <option selected={limit == 20}>20</option>
        //         </select>
        //     </div>
        //     </div>
        //   );
        // },
        textLabels: {
            pagination: {
                next: 'Next Page',
                previous: 'Previous Page',
                displayRows: 'of',
            },
        },
        onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
            if (allRowsSelected.length > 0) {
                const newarr = allRowsSelected.map((item, index) => {
                    return admin.list[item['dataIndex']]['id']
                })

                setTimeout(() => {
                    setDeleteIds(newarr)
                })
                setDeleteButton(true)
            } else {
                setDeleteButton(false)
            }
        },
        responsive: 'standard',
    }

    const CustomCheckbox = (props) => {
        let newProps = Object.assign({}, props)
        newProps.color = props['data-description'] === 'row-select' ? 'secondary' : 'primary'

        if (props['data-description'] === 'row-select') {
            return <Checkbox />
        } else {
            return <Checkbox {...newProps} />
        }
    }
    return (
        <div className="userPage adminPage merchantlist userPageWithList">
            <Loader loading={loaders.isFetching} />

            <div className="scroll-fix">
                <div>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={4}>
                            <div style={{ display: 'flex' }}>
                                <div>
                                    <p className="headinguser">Admin Management</p>
                                    {/* <p className="subheadinggraph">
                    Merchant of Climate Mobility & Safety
                  </p> */}
                                </div>
                            </div>
                        </Grid>
                        <Grid
                            style={{
                                alignItems: 'center',
                                justifyContent: 'center',
                                display: 'flex',
                            }}
                            item
                            xs={12}
                            sm={12}
                            md={8}
                        >
                            <Grid container spacing={2}>
                                <Grid
                                    style={{
                                        alignItems: 'right',
                                        justifyContent: 'right',
                                        display: 'flex',
                                    }}
                                    item
                                    xs={12}
                                    sm={12}
                                    md={7}
                                >
                                    <Button
                                        onClick={(e) => handleDeleteModal(e)}
                                        style={{
                                            visibility: deleteAllButton
                                                ? deleteAllButton
                                                : 'hidden',
                                        }}
                                        className="deleteAll"
                                    >
                                        <i className="  deleteButton">
                                            <img src={require('../../assets/images/Delete.png')} />
                                        </i>{' '}
                                        Delete All
                                    </Button>
                                </Grid>

                                <Grid item xs={12} sm={12} md={4}>
                                    <button
                                        className="btn btn-primary btn-block merchantAddButton"
                                        onClick={() => handleModal()}
                                    >
                                        Add Admin
                                    </button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
                <div className="pagination-wrapper-admin">
                    <div className="pagination">
                        <p>
                            Showing {admin.list.length} out of {admin.total_users} admins{' '}
                        </p>
                    </div>

                    <Stack spacing={2}>
                        <Pagination
                            count={Math.ceil(admin.total_users / limit)}
                            page={page}
                            onChange={(e, value) => setNewPage(value)}
                            color="primary"
                        />
                    </Stack>
                    <div className="pagination2">
                        <p>Rows Per Page</p>
                        <select className='pagination-select' onChange={(e) => updatePagination(e)}>
                            <option selected={limit == 10}>10</option>
                            <option selected={limit == 20}>20</option>
                            <option selected={limit == 30}>30</option>
                        </select>
                    </div>
                </div>
            </div>

            <div ref={tableRef} style={{ overflowY: 'auto', height: tableHeight }}>
                <MUIDataTable
                    className="custommuitablestyle"
                    columns={columns}
                    data={data}
                    responsive={responsive}
                    // components={{
                    //   Checkbox: CustomCheckbox,
                    // }}
                    // rowHover={true}
                    options={options}
                />
            </div>

            <Modal
                open={openModal}
                onClose={handleModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} className="popupModal">
                    <Typography
                        id="modal-modal-title"
                        className="popuptitle"
                        variant="h6"
                        component="h2"
                    >
                        {edit ? 'Update Admin' : 'Add Admin'}
                        <img
                            onClick={() => handleModal()}
                            style={{ float: 'right', cursor: 'pointer' }}
                            src={require('../../assets/images/Vector 635.png')}
                        />
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <LocalForm model="user" onSubmit={(values) => handleAddSubmit(values)}>
                            <Row>
                                {/* <Col className='column' sm="12" md="12">
        <FormGroup >
        <Label >Image</Label>
          <div className='imageinputfield' >
        <i class="  icon icons"><img src={require("../../assets/images/upload.png")} /></i>
          <Control.text
            model="user.image"
            className="form-control imageField input-field"
            id="user.username"
            placeholder="Drop files here to upload..."
           
          />
          <i class="  icon icons uploadicon"><button  className="btn btn-primary btn-block userAddButton " onClick={()=>handleModal()}>Upload
        </button></i>     
            </div>
        
        </FormGroup>
      </Col> */}
                                <FormGroup>
                                    <div style={{ display: 'flex' }}>
                                        <Control.text
                                            model="user.firstName"
                                            className="form-control nameField  input-field"
                                            id="user.firstName"
                                            defaultValue={edit ? editData[5] : ''}
                                            placeholder="First Name"
                                            parser={(value) => updateValue(value)}
                                            errors={{
                                                adminFirstNameField: (val) => !val,
                                                firstValid: (val) => val && val.length < 2,
                                            }}
                                        />
                                    </div>
                                    <Errors
                                        model="user.firstName"
                                        errors={{
                                            adminFirstNameField,
                                            firstValid,
                                        }}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Col className="column" sm="12" md="12">
                                        <div style={{ display: 'flex' }}>
                                            <Control.text
                                                model="user.lastName"
                                                className="form-control nameField captilize input-field"
                                                id="user.lastName"
                                                defaultValue={edit ? editData[6] : ''}
                                                placeholder="Last Name"
                                                autocapitalize
                                                errors={{
                                                    adminLastNameField: (val) => !val,
                                                    lastValid: (val) => val && val.length < 2,
                                                }}
                                            />
                                        </div>
                                        <Errors
                                            model="user.lastName"
                                            errors={{
                                                adminLastNameField,
                                                lastValid,
                                            }}
                                        />
                                    </Col>
                                </FormGroup>
                                <Col className="column" sm="12" md="12">
                                    <FormGroup>
                                        <div style={{ display: 'flex' }}>
                                            <Control.text
                                                model="user.email"
                                                className="form-control nameField input-field"
                                                id="user.email"
                                                defaultValue={edit ? editData[1] : ''}
                                                disabled={edit}
                                                placeholder="Email"
                                                errors={{
                                                    emptyEmail: (val) => !val,
                                                    invalidEmail: (val) =>
                                                        val && !Match.validateEmail(val),
                                                }}
                                            />
                                        </div>
                                        <Errors
                                            model="user.email"
                                            errors={{
                                                emptyEmail,
                                                invalidEmail,
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                                {!edit && (
                                    <Col className="column" sm="12" md="12">
                                        <FormGroup>
                                            <div className="input-wrapper">
                                                <i class=" icon">
                                                    <img
                                                        src={require('../../assets/images/unlock.png')}
                                                    />
                                                </i>
                                                <Control.text
                                                    model="user.password"
                                                    className="form-control input-field merchantPassword password"
                                                    id="user.password"
                                                    value={passVal}
                                                    maxLength={20}
                                                    style={{ height: '65px' }}
                                                    type={pass ? 'password' : 'text'}
                                                    onChange={(e) => setPassVal(e.target.value)}
                                                    placeholder="Password"
                                                    onPaste={(e) => handleChange(e)}
                                                    onCopy={(e) => handleChange(e)}
                                                    errors={{
                                                        Password: (val) => !val,
                                                        invalidPass1: (val) =>
                                                            val && !Match.validatePassword(val),
                                                        invalid2: (val) =>
                                                            val && !Match.validatePassword(val),
                                                        invalid3: (val) =>
                                                            val && !Match.validatePassword(val),
                                                        invalid4: (val) =>
                                                            val && !Match.validatePassword(val),
                                                        invalid5: (val) =>
                                                            val && !Match.validatePassword(val),
                                                        invalid6: (val) =>
                                                            val && !Match.validatePassword(val),
                                                        invalid7: (val) =>
                                                            val && !Match.validatePassword(val),
                                                    }}
                                                ></Control.text>
                                                {pass && (
                                                    <i
                                                        class=" iconeye"
                                                        style={{ top: '20px' }}
                                                        onClick={() => setPass(false)}
                                                    >
                                                        <img
                                                            src={require('../../assets/images/eye-slash.png')}
                                                        />
                                                    </i>
                                                )}

                                                {!pass && (
                                                    <i
                                                        class=" iconeye"
                                                        style={{ top: '20px' }}
                                                        onClick={() => setPass(true)}
                                                    >
                                                        <img
                                                            src={require('../../assets/images/eye.png')}
                                                        />
                                                    </i>
                                                )}
                                            </div>
                                            <Errors
                                                model="user.password"
                                                style={{ width: '408px' }}
                                                errors={{
                                                    Password,
                                                    invalidPass1,
                                                    invalid2,
                                                    invalid3,
                                                    invalid4,
                                                    invalid5,
                                                    invalid6,
                                                    invalid7,
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                )}

                                <Col sm="12 column form-button-spacing">
                                    <div>
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-block "
                                        >
                                            {edit ? 'Update Admin' : 'Add Admin'}
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </LocalForm>
                    </Typography>
                </Box>
            </Modal>
            <Modal
                open={openCongrModal}
                onClose={() => {
                    setOpenCongrModal(false)
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleDeletePopup} className="congratespopup">
                    <div className="textDeletePopup">
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            You have successfully {edit ? 'updated' : 'added'} the admin.
                        </Typography>

                        {/* <Typography>
              <div className='buttonGroupDelete'>

                <button className="btn btn-primary btn-block okaybutton" onClick={() => { setOpenCongrModal(false) }}>Okay
                </button>
              </div>
            </Typography> */}
                    </div>
                </Box>
            </Modal>
            <Modal
                open={open}
                onClose={(e) => handleDeleteModal(e)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleDeletePopup} className="deletePopup">
                    <div className="iconshadow">
                        <i className=" deleteIconPopup">
                            <button>
                                <img height={20} src={require('../../assets/images/Delete.png')} />
                            </button>
                        </i>
                    </div>
                    <div className="textDeletePopup">
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Are you Sure?
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            Are you sure you want delete this? This action cannot be undone.
                        </Typography>

                        <Typography>
                            <div className="buttonGroupDelete">
                                <button
                                    className="btn btn-primary btn-block cancelButton"
                                    onClick={(e) => handleDeleteModal(e)}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-primary btn-block deleteButtonUser"
                                    onClick={(e) => deleteUser(e)}
                                >
                                    <img src={require('../../assets/images/DeleteWhite.png')} />{' '}
                                    Delete
                                </button>
                            </div>
                        </Typography>
                    </div>
                </Box>
            </Modal>
        </div>
    )
}

export default AdminManagement
